import { lazy, Suspense, useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "./i18n";
import Home from "./pages/Home";

const RoutesIndex = lazy(() => import("./pages/RoutesIndex"));
const RoutePage = lazy(() => import("./pages/RoutePage"));
const BlogList = lazy(() => import("./pages/BlogList"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Resources = lazy(() => import("./pages/Resources"));
const Enquiry = lazy(() => import("./pages/Enquiry"));
const Prices = lazy(() => import("./pages/Prices"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <LangProvider>
        <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fr" element={<Home />} />
          <Route path="/routes" element={<RoutesIndex />} />
          <Route path="/fr/routes" element={<RoutesIndex />} />
          <Route path="/routes/:slug" element={<RoutePage />} />
          <Route path="/fr/routes/:slug" element={<RoutePage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/fr/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/fr/blog/:slug" element={<BlogPost />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/fr/resources" element={<Resources />} />
          <Route path="/enquiry" element={<Enquiry />} />
          <Route path="/fr/enquiry" element={<Enquiry />} />
          <Route path="/prices" element={<Prices />} />
          <Route path="/fr/prices" element={<Prices />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </Suspense>
        </LangProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
